/* eslint-disable no-undef */
import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);
